import { Directive, Input, OnDestroy, OnInit, TemplateRef, ViewContainerRef } from '@angular/core';
import { AppRoleDims, AppRoleKey } from '@nk/data-entities-lib';
import { Subject } from 'rxjs';
import { takeUntil } from 'rxjs/operators';
import { AppRoleService } from '../../services/app-role.service';
import { AppService } from '../../services/app.service';
import { hasAllRequiredRoles } from '../../utils/role.utils';

@Directive({
  selector: '[nkIfRole]',
  standalone: true,
})
export class IfRoleDirective implements OnInit, OnDestroy {
  @Input() public nkIfRole: AppRoleKey[] | undefined;
  @Input() public nkIfRoleElse: TemplateRef<unknown> | undefined;
  private _destroy$ = new Subject<void>();

  constructor(
    private _templateRef: TemplateRef<unknown>,
    private _viewContainer: ViewContainerRef,
    private _appService: AppService,
    private _appRoleService: AppRoleService,
  ) {}

  public ngOnInit(): void {
    if (this.nkIfRole) {
      // clear the view first and subscribe to check if is allowed to access
      this._viewContainer.clear();
      this._subscribeForRoles();
    } else {
      // if key is not provided, it is assumed that feature check is not required at all
      this._viewContainer.createEmbeddedView(this._templateRef);
    }
  }

  private _subscribeForRoles(): void {
    this._appRoleService.appRoleListByMembershipCache
      .get()
      .pipe(takeUntil(this._destroy$))
      .subscribe((roles) => {
        const roleDim = new AppRoleDims(roles);
        if (hasAllRequiredRoles(roleDim.flags, this.nkIfRole)) {
          this._viewContainer.createEmbeddedView(this._templateRef);
        } else {
          if (this.nkIfRoleElse) {
            this._viewContainer.createEmbeddedView(this.nkIfRoleElse);
          } else {
            this._viewContainer.clear();
          }
        }
      });
  }

  public ngOnDestroy(): void {
    this._destroy$.next();
  }
}
